exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3lAmE{position:absolute;right:6px;top:0;margin:6px}.x27Ii{position:relative}._2w0Nk{position:relative;display:flex;align-items:stretch;border:solid 1px;border-radius:6px;box-sizing:border-box;font-family:\"HelveticaNeueW01-55Roma\",\"HelveticaNeueW02-55Roma\",\"HelveticaNeueW10-55Roma\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",\"メイリオ, meiryo\",\"ヒラギノ角ゴ pro w3\",\"hiragino kaku gothic pro\",\"sans-serif\";font-family:var(--wsr-font-family, \"HelveticaNeueW01-55Roma\",\"HelveticaNeueW02-55Roma\",\"HelveticaNeueW10-55Roma\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",\"メイリオ, meiryo\",\"ヒラギノ角ゴ pro w3\",\"hiragino kaku gothic pro\",\"sans-serif\");border-color:#C1E4FE;background-color:#fff;color:#162D3D}._2w0Nk *{box-sizing:border-box}._2w0Nk._1kydq textarea::-moz-placeholder{color:rgba(22,45,61,0.3)}._2w0Nk._1kydq textarea:-ms-input-placeholder{color:rgba(22,45,61,0.3)}._2w0Nk._1kydq textarea::-ms-input-placeholder{color:rgba(22,45,61,0.3)}._2w0Nk._1kydq textarea::placeholder{color:rgba(22,45,61,0.3)}._2w0Nk .B1yvT{color:#162D3D}._2w0Nk:hover{background-color:#EAF7FF}._2w0Nk._3ZW5n{background-color:#EAF7FF}._2w0Nk._2P957{outline:none;border-color:#3899EC;box-shadow:0 0 0 3px #AADBFC;background-color:#fff}._2w0Nk._2P957.MfaS9{outline:none;border-color:#EE5951;box-shadow:0 0 0 3px #FFD7D7}._2w0Nk._2P957._1pgfx{outline:none;border-color:#FDB10C;box-shadow:0 0 0 3px #FEF0BA}._2w0Nk.MfaS9{border-color:#ee5951;box-shadow:none}._2w0Nk._1pgfx{border-color:#fdb10c;box-shadow:none}._2w0Nk._1kydq{border-color:rgba(22,45,61,0.2);background-color:#fff;color:rgba(22,45,61,0.3)}._2w0Nk._1kydq .B1yvT{color:rgba(22,45,61,0.3)}.B1yvT{flex-grow:1;flex-shrink:1;min-width:20px;min-height:36px;padding:6px 12px;margin:0;border:0;outline:0;background:transparent;cursor:auto;font-family:\"HelveticaNeueW01-55Roma\",\"HelveticaNeueW02-55Roma\",\"HelveticaNeueW10-55Roma\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",\"メイリオ, meiryo\",\"ヒラギノ角ゴ pro w3\",\"hiragino kaku gothic pro\",\"sans-serif\";font-family:var(--wsr-font-family, \"HelveticaNeueW01-55Roma\",\"HelveticaNeueW02-55Roma\",\"HelveticaNeueW10-55Roma\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",\"メイリオ, meiryo\",\"ヒラギノ角ゴ pro w3\",\"hiragino kaku gothic pro\",\"sans-serif\");font-size:16px;line-height:24px}.B1yvT::-webkit-input-placeholder{color:#7A92A5}.B1yvT:-moz-placeholder{color:#7A92A5}.B1yvT::-moz-placeholder{color:#7A92A5}.B1yvT:-ms-input-placeholder{color:#7A92A5}.B1yvT::-moz-selection{background:#d3edff}.B1yvT::selection{background:#d3edff}.B1yvT::-moz-selection{background:#d3edff}.B1yvT::-webkit-scrollbar{width:18px;background-color:#fff}.B1yvT::-webkit-scrollbar-button{display:none;height:6px}.B1yvT::-webkit-scrollbar-thumb{background-color:#C1E4FE;background-clip:content-box;border-radius:10px;border:5px solid transparent;height:72px}.B1yvT::-webkit-scrollbar-thumb:hover{background-color:#4EB7F5}.B1yvT::-webkit-scrollbar-thumb:active{background-color:#3899EC}.B1yvT::-webkit-scrollbar-thumb{height:30px}.B1yvT::-webkit-scrollbar{border-radius:0 6px 6px 0}.B1yvT._285kX{font-family:\"HelveticaNeueW01-55Roma\",\"HelveticaNeueW02-55Roma\",\"HelveticaNeueW10-55Roma\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",\"メイリオ, meiryo\",\"ヒラギノ角ゴ pro w3\",\"hiragino kaku gothic pro\",\"sans-serif\";font-family:var(--wsr-font-family, \"HelveticaNeueW01-55Roma\",\"HelveticaNeueW02-55Roma\",\"HelveticaNeueW10-55Roma\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",\"メイリオ, meiryo\",\"ヒラギノ角ゴ pro w3\",\"hiragino kaku gothic pro\",\"sans-serif\");font-size:14px;line-height:18px}._3HMYg{position:absolute;top:-30px;right:0;font-size:14px;line-height:1.3;color:#7A92A5}._3HMYg::-webkit-input-placeholder{color:#a3abb0}._3HMYg:-moz-placeholder{color:#a3abb0}._3HMYg::-moz-placeholder{color:#a3abb0}._3HMYg:-ms-input-placeholder{color:#a3abb0}._2js7Q>.B1yvT{padding-right:34px}._3DOL_>textarea{resize:vertical}._2yZDP>textarea{resize:none}.rtl ._3lAmE,[dir='rtl'] ._3lAmE{position:absolute;left:6px;top:0;right:auto}.rtl .B1yvT,[dir='rtl'] .B1yvT{direction:rtl}.rtl ._3HMYg,[dir='rtl'] ._3HMYg{right:auto}.rtl ._2js7Q>.B1yvT,[dir='rtl'] ._2js7Q>.B1yvT{padding-left:34px;padding-right:12px}\n", ""]);

// Exports
exports.locals = {
	"D10": "#162D3D",
	"d10": "#162D3D",
	"D20": "#32536A",
	"d20": "#32536A",
	"D30": "#577083",
	"d30": "#577083",
	"D40": "#7A92A5",
	"d40": "#7A92A5",
	"D50": "#B6C1CD",
	"d50": "#B6C1CD",
	"D55": "#CBD3DC",
	"d55": "#CBD3DC",
	"D60": "#DFE5EB",
	"d60": "#DFE5EB",
	"D70": "#F0F4F7",
	"d70": "#F0F4F7",
	"D80": "#fff",
	"d80": "#fff",
	"B00": "#2B81CB",
	"b00": "#2B81CB",
	"B05": "#308DDD",
	"b05": "#308DDD",
	"B10": "#3899EC",
	"b10": "#3899EC",
	"B20": "#4EB7F5",
	"b20": "#4EB7F5",
	"B25": "#A1D7FB",
	"b25": "#A1D7FB",
	"B27": "#B3E0FB",
	"b27": "#B3E0FB",
	"B30": "#C1E4FE",
	"b30": "#C1E4FE",
	"B40": "#DAEFFE",
	"b40": "#DAEFFE",
	"B50": "#EAF7FF",
	"b50": "#EAF7FF",
	"B60": "#F4FAFE",
	"b60": "#F4FAFE",
	"F00": "#AADBFC",
	"f00": "#AADBFC",
	"P00": "#8E21B1",
	"p00": "#8E21B1",
	"P10": "#AA4DC8",
	"p10": "#AA4DC8",
	"P20": "#CD68ED",
	"p20": "#CD68ED",
	"P30": "#E5C9EE",
	"p30": "#E5C9EE",
	"P40": "#EEDBF4",
	"p40": "#EEDBF4",
	"P50": "#FAEEFF",
	"p50": "#FAEEFF",
	"P60": "#FAF7FC",
	"p60": "#FAF7FC",
	"O00": "#EA5F0E",
	"o00": "#EA5F0E",
	"O10": "#FB7D33",
	"o10": "#FB7D33",
	"O20": "#FF9A48",
	"o20": "#FF9A48",
	"R00": "#D6453D",
	"r00": "#D6453D",
	"R05": "#D8504C",
	"r05": "#D8504C",
	"R10": "#EE5951",
	"r10": "#EE5951",
	"R20": "#f66",
	"r20": "#f66",
	"R30": "#FFD7D7",
	"r30": "#FFD7D7",
	"R40": "#FFE1E1",
	"r40": "#FFE1E1",
	"R50": "#FFEBEB",
	"r50": "#FFEBEB",
	"R60": "#FFF5F5",
	"r60": "#FFF5F5",
	"G00": "#44823F",
	"g00": "#44823F",
	"G05": "#61AD5A",
	"g05": "#61AD5A",
	"G10": "#60BC57",
	"g10": "#60BC57",
	"G20": "#80C979",
	"g20": "#80C979",
	"G30": "#C9EEBC",
	"g30": "#C9EEBC",
	"G40": "#DEF4D4",
	"g40": "#DEF4D4",
	"G50": "#EDF9E5",
	"g50": "#EDF9E5",
	"G60": "#F2FBEF",
	"g60": "#F2FBEF",
	"Y00": "#C68801",
	"y00": "#C68801",
	"Y05": "#EDA200",
	"y05": "#EDA200",
	"Y10": "#FDB10C",
	"y10": "#FDB10C",
	"Y20": "#FAC249",
	"y20": "#FAC249",
	"Y30": "#FEF0BA",
	"y30": "#FEF0BA",
	"Y40": "#FEF4CD",
	"y40": "#FEF4CD",
	"Y50": "#FDF7DF",
	"y50": "#FDF7DF",
	"Y60": "#FFFCF0",
	"y60": "#FFFCF0",
	"A1": "#3370FB",
	"a1": "#3370FB",
	"A2": "#7852D2",
	"a2": "#7852D2",
	"A3": "#17B0E2",
	"a3": "#17B0E2",
	"A4": "#C53E99",
	"a4": "#C53E99",
	"A5": "#FDB10C",
	"a5": "#FDB10C",
	"A6": "#3D9FA1",
	"a6": "#3D9FA1",
	"B1": "#EF73C0",
	"b1": "#EF73C0",
	"B2": "#FF8D41",
	"b2": "#FF8D41",
	"B3": "#ED6779",
	"b3": "#ED6779",
	"B4": "#125b8f",
	"b4": "#125b8f",
	"C1": "#4abd81",
	"c1": "#4abd81",
	"C2": "#2682CD",
	"c2": "#2682CD",
	"C3": "#68A4D5",
	"c3": "#68A4D5",
	"C4": "#FF8E8C",
	"c4": "#FF8E8C",
	"D10-05": "rgba(22,45,61,0.05)",
	"d1005": "rgba(22,45,61,0.05)",
	"D10-10": "rgba(22,45,61,0.1)",
	"d1010": "rgba(22,45,61,0.1)",
	"D10-20": "rgba(22,45,61,0.2)",
	"d1020": "rgba(22,45,61,0.2)",
	"D10-30": "rgba(22,45,61,0.3)",
	"d1030": "rgba(22,45,61,0.3)",
	"status": "_3lAmE",
	"wrapper": "x27Ii",
	"root": "_2w0Nk",
	"disabled": "_1kydq",
	"inputArea": "B1yvT",
	"hasHover": "_3ZW5n",
	"hasFocus": "_2P957",
	"hasError": "MfaS9",
	"hasWarning": "_1pgfx",
	"sizeSmall": "_285kX",
	"counter": "_3HMYg",
	"hasStatus": "_2js7Q",
	"resizable": "_3DOL_",
	"nonResizable": "_2yZDP"
};